
// 项目列表接口 api
import axios from '../utils/axios'

/* 获取总项目列表
* professionAndDirectionList: 专业方向
* schoolBegin: 开课时间
*/
export const getProjectAllList = function(data: {
    code?: string;
    souCourseName?: string;
    teacherName?: string;
    teacherLevel?: string;
    teacherSchool?: string;
    userIdList?: string[];
    professionAndDirectionList?: number[][];
    typeId?: number | '';
    status?: string;
    isShow?: string;
    schoolBegin?: string;
    limit: number;
    page?: number;
    helperUserId?: string;
 }) {
    return axios.post('/project/getProjectAllList', data)
}

// 总项目中获取项目详情
export const getProjectAllById = function(id: number) {
    return axios.get('/project/getProjectAllById?id=' + id)
}

// 编辑保存项目信息
export const setProjectAllById = function(data: {
    id: number;
    quota: number;
    doubleSouCourseName?: string;
    userId?: string;
    projectAllCostList?: { name: string; price: string }[];
    isShowUserIdList?: string[];  //共享人id
    isShowDepartmentIdList?: string[]; //共享部门id
    teacherUserId?: string;
    thesisUserId?: string;
    helperUserId?: string;
}) { return axios.post('/project/setProjectAllById', data) }

// 批量设置数据
export const setProjectAllByIdList = function(data: {
    idList: number[];
    isShowUserIdList?: string[];
    isShowDepartmentIdList?: string[];
    quota?: number | '';
    userId?: string;
}) { return axios({ url: '/project/setProjectAllByIdList', method: 'post', data }) }

// 数据统计页
export const getProjectAllStatisticalData = function(data: { timeStr: string; souCourseTypeId: number }) {
    return axios.post('/project/getProjectAllStatisticalData',data)
}

// 总醒目数据统计 排行榜导出
export const projectAllRankListExportData = function(data: { types: string; timeStr: string; souCourseTypeId: number; keys?: string }) {
    return axios.post('/project/projectAllRankListExportData', data)
}

// 导出总项目列表
export const projectAllExportData = function(data: {
    code: string;
    name: string;
    teacherName: string;
    teacherLevel: string;
    teacherSchool: string;
    userIdList: string[];
    professionAndDirectionList: number[][];
    typeId: number | '';
    status: string;
    isShow: string;
    schoolBegin: string;
    keys?: string;
}) {
    return axios.post('/project/projectAllExportData', data)
}

// 合作伙伴项目列表
export const getProjectMarketCooperationList = function(data: {
    souCourseName: string;
    souTeacherName: string;
    marketCooperationName: string;
    marketCooperationDirectorUserIdList: string[];
    superiorMarketCooperationName: string;
    souCourseTypeId: number;
    marketCooperationSource: string;
    marketCooperationCommissionType: string;
    souCourseSchoolBegin: string;
    limit: number;
    page: number;
}) { return axios.post('/project/getProjectMarketCooperationList', data) }

export const getProjectMarketCooperationByMarketCooperationId = function(data: {
    marketCooperationIdList: number[];
    souCourseTypeId?: number;
    name: string;
    isTwo: string;
    isDraft: string;
    page: number;
    limit: number;
}) { return axios.post('/project/getProjectMarketCooperationByMarketCooperationId', data) }

// 暂存选择的合作伙伴，项目
export const setProjectMarketCooperation = function(data: { marketCooperationIdList: number[]; projectAllIdList: number[]; isTwo: string; draftId?: number | '';isAll: string }) {
    return axios.post('/project/setProjectMarketCooperation', data)
}

// 获取暂存的合作伙伴列表
export const getPreProjectMarketCooperationList = function() {
    return axios.get('/project/getPreProjectMarketCooperationList')
}

// 获取暂存的合作伙伴下的项目列表
// export const getPreProjectMarketCooperationListByMarketCooperationId1 = function(id: number, draftId?: number | '') {
//     return axios.get(draftId ? '/project/getPreProjectMarketCooperationListByMarketCooperationId?marketCooperationId=' + id + '&draftId=' + draftId : '/project/getPreProjectMarketCooperationListByMarketCooperationId?marketCooperationId=' + id)
// }

// get改post
export const getPreProjectMarketCooperationListByMarketCooperationId = function(
    data: {
        marketCooperationId: number;
        souCourseName?: string;
        limit?: number;
        page?: number;
        draftId?: number | '';
    }
) {
    return axios.post('/project/getPreProjectMarketCooperationListByMarketCooperationId', data)
}


// 是否存在暂存的项目
export const getPreProjectMarketCooperation = function() {
    return axios.get('/project/getPreProjectMarketCooperation')
}

// 查询可新增的机构
export const getMarketCooperationList = function(data: { name: string; limit: number; page: number; draftId?: number | '' }) {
    return axios.post('/project/getMarketCooperationList', data)
}

// 添加机构
export const setPreProjectMarketCooperation = function(data: { marketCooperationIdList: number[]; draftId?: number | '' }) {
    return axios.post('/project/setPreProjectMarketCooperation', data)
}

// 删除机构
export const delPreProjectMarketCooperationByMarketCooperationId = function(data: { marketCooperationId: number; draftId?: number | '' }) {
    return axios.delete('/project/delPreProjectMarketCooperationByMarketCooperationId', { data })
}

// 删除项目
export const delPreProjectMarketCooperationById = function(data: { id: number; draftId?: number | '' }) {
    return axios.delete('/project/delPreProjectMarketCooperationById', { data })
}

// 提交、存草稿
export const setProjectMarketCooperationByIsDraft = function(data: { isDraft: string }) {
    return axios.post('/project/setProjectMarketCooperationByIsDraft', data)
}

// 取消暂存
export const delPreProjectMarketCooperation = function() {
    return axios.get('/project/delPreProjectMarketCooperation')
}

// 合作伙伴列表导出
export const projectMarketCooperationExportData = function(data: any) {
    return axios.post('/project/projectMarketCooperationExportData', data)
}

// 查看合作伙伴详情
export const getProjectMarketCooperationById = function(id: number) {
    return axios.get('/project/getProjectMarketCooperationById?id=' + id)
}

// 总项目报名学员
export const getCustomerListById = function(data: {
    gradeList: string[];
    id: number;
    customerName: string;
    prevMarketCooperationName: string;
    dissertationType: string;
}) {
    return axios.post('/project/getCustomerListById', data)
}

// 总项目报名学员导出
export const getCustomerListByIdExportData = function(data: { gradeList: string[]; id: number; keys?: string }) {
    return axios.post('/project/getCustomerListByIdExportData', data)
}


// 总项目删除
export const delProjectAllById = function(data: { id: number }) {
    return axios.delete('/project/delProjectAllById', { data })
}

/*
* 查看报名学员跟进记录*/

export const getCustomerFollowListByCustomerId = function (data: { id: number; customerId: number; customerType: string }) {
   return axios.get('/project/getCustomerFollowListByCustomerId',{params: data})
}
// 服务完成
export const setFinanceOrderFinishByFinanceOrderId = function (
    data: { financeOrderIdList: object[]; url: string }
) {
    return axios.post('/project/setFinanceOrderFinishByFinanceOrderId', data)
}


/*
* 查看报名学员的所有订单信息
GET*/
export const getFinanceOrdreListByCustomerId = function (data: {
    id: number;
    customerId: number;
    customerType: string;
}) {
    return axios.get('/project/getFinanceOrdreListByCustomerId',{params: data})
}
